// extracted by mini-css-extract-plugin
export default {"fullWidth":"Kn-z","image":"Ln-z","lazyLoadPicture":"Mn-z","lazyLoadSpinner":"Nn-z","lazyLoadSpin":"On-z","lazyLoadImage":"Pn-z","hasStyledAspectRatio":"Qn-z"};